import { Checkbox, Col, Divider, Form, Row, Modal, Image } from 'antd';
import { ArrowLeftOutlined, DeleteOutlined, CloudUploadOutlined, EyeOutlined } from '@ant-design/icons';
import { useMemo, useState } from 'react';

const BusinessUploads = (props) => {

    const { tabId, ItemLayoutCols, styleTabLayout, mainLogoName, faviconeName, backgroundName, hasDefaultSlider, setHasDefaultSlider, handleChange, deleteMainFiles, desktopBannerName, setDesktopBannerName, setBackgroundName, tabletBannerName, setTabletBannerName, mobileBannerName, setMobileBannerName, deleteBannerFiles, footerLogoName, layout } = props;

    const [previewSrc, setPreviewSrc] = useState('');
    const [isPreviewVisible, setIsPreviewVisible] = useState(false);

    const isPreviewable = (src) => typeof src === 'string' && /^(https?:\/\/|data:image|blob:|\/)/i.test(src);

    const UploadRow = ({ fileName, onChange, onDelete, disabled = false, placeholder = 'هنوز فایلی انتخاب نشده', helper }) => {
        const canPreview = useMemo(() => isPreviewable(fileName), [fileName]);

        return (
            <Row className="upload-row">
                <Col span={24}>
                    <div className="upload-card">
                        <div className="upload-control">
                            <label className={`upload-button ${disabled ? 'is-disabled' : ''}`}>
                                <CloudUploadOutlined />
                                <span>{disabled ? 'غیرفعال' : 'انتخاب فایل'}</span>
                                <input disabled={disabled} type="file" onChange={onChange} />
                            </label>
                            {helper && <span className="upload-helper">{helper}</span>}
                        </div>
                        <div className="upload-meta">
                            {fileName ? (
                                <>
                                    {canPreview && <Image preview={false} src={fileName} alt="preview" className="upload-thumb" />}
                                    <ArrowLeftOutlined />
                                    <span className="upload-name">{fileName}</span>
                                    <div className="upload-actions">
                                        {canPreview && (
                                            <button type="button" className="upload-preview" onClick={() => { setPreviewSrc(fileName); setIsPreviewVisible(true); }}>
                                                <EyeOutlined />
                                                <span>نمایش</span>
                                            </button>
                                        )}
                                        <button type="button" className="upload-delete" onClick={onDelete}>
                                            <DeleteOutlined />
                                            <span>حذف</span>
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <span className="upload-placeholder">{placeholder}</span>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        );
    };

    return (
        <Form
            {...layout}
            layout="horizontal"
            name="add_company"
            className='business-form-uploads'
        >
            <div style={{ overflowX: 'hidden', paddingLeft: 26 }} className={`tabViewPort ${(tabId === "2") ? 'visibleTab' : null}`}>
                <Row gutter={16}>
                    <Col
                        {...ItemLayoutCols}>
                        <Form.Item {...styleTabLayout} className="formItem" name="logo" label="لوگوی اصلی">
                            <div className="upload-description">
                                <div className='ltr-direction'>X *  100(max)   :اندازه مناسب </div>
                                <div>حجم مناسب : حداکثر  10KB</div>
                                <div>فقط عکس قابل قبول است</div>
                            </div>
                            <UploadRow
                                fileName={mainLogoName}
                                onChange={(e) => handleChange(e, 'mainlogo')}
                                onDelete={() => deleteMainFiles('mainlogo', 'business-logo')}
                                helper="PNG/JPG • حداکثر 10KB"
                            />
                        </Form.Item>
                    </Col>
                    <Col {...ItemLayoutCols}>
                        <Form.Item {...styleTabLayout} className="formItem" name="favicon" label="فوآیکون">
                            <div className="upload-description">
                                <div>اندازه مناسب :  16 * 16</div>
                                <div>حجم مناسب : حداکثر  7KB</div>
                                <div>فقط عکس قابل قبول است</div>
                            </div>
                            <UploadRow
                                fileName={faviconeName}
                                onChange={(e) => handleChange(e, 'favicone')}
                                onDelete={() => deleteMainFiles('favicon', 'business-favicon')}
                                helper="PNG/ICO • حداکثر 7KB"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Row gutter={16}>
                    <Col {...ItemLayoutCols}>
                        <Form.Item {...styleTabLayout} className="formItem" name="sliderImage">
                            <Form.Item className="formItem" name="defaultSlider" valuePropName="checked">
                                <Checkbox
                                    checked={hasDefaultSlider}
                                    onChange={(e) => setHasDefaultSlider(e.target.checked)}
                                >فعال شدن بک گراند پیش فرض</Checkbox>
                            </Form.Item>
                            <label>چنانچه تمایل به اسلایدر پیش فرض ندارید، بک گراند مورد نظر خود را با مشخصات زیر آپلود نمایید</label>

                            <div className="upload-description">
                                <div>اندازه مناسب : 680 × 1600 </div>
                                <div>حجم مناسب : حداکثر  100KB</div>
                                <div>فقط عکس قابل قبول است</div>
                            </div>
                            <UploadRow
                                fileName={backgroundName}
                                onChange={(e) => handleChange(e, 'background')}
                                onDelete={() => {
                                    if (backgroundName !== 'wl-background.png' && backgroundName !== 'main-slider.jpg') {
                                        deleteMainFiles('background', 'business-background');
                                    }
                                    setBackgroundName('');
                                }}
                                disabled={hasDefaultSlider}
                                helper="PNG/JPG • حداکثر 100KB"
                            />
                        </Form.Item>
                    </Col>
                    <Col {...ItemLayoutCols}>
                        <Form.Item {...styleTabLayout} className="formItem" name="desktopBanner" label="بنر دسکتاپ">
                            <div className="upload-description">
                                <div className='ltr-direction'>   1650 * X :اندازه مناسب </div>
                                <div>حجم مناسب : حداکثر  60KB</div>
                                <div>فقط عکس قابل قبول است</div>
                            </div>
                            <UploadRow
                                fileName={desktopBannerName}
                                onChange={(e) => handleChange(e, 'desktop')}
                                onDelete={() => { deleteBannerFiles(desktopBannerName, 'desktop'); setDesktopBannerName(''); }}
                                helper="PNG/JPG • حداکثر 60KB"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Row gutter={16}>
                    <Col {...ItemLayoutCols}>
                        <Form.Item {...styleTabLayout} className="formItem" name="tabletBanner" label="بنر تبلت">
                            <div className="upload-description">
                                <div>اندازه مناسب : 100 × 1024 </div>
                                <div>حجم مناسب : حداکثر 50KB</div>
                                <div>فقط عکس قابل قبول است</div>
                            </div>
                            <UploadRow
                                fileName={tabletBannerName}
                                onChange={(e) => handleChange(e, 'tablet')}
                                onDelete={() => {
                                    deleteBannerFiles(tabletBannerName, 'tablet');
                                    setTabletBannerName('');
                                }}
                                helper="PNG/JPG • حداکثر 50KB"
                            />
                        </Form.Item>
                    </Col>
                    <Col {...ItemLayoutCols}>
                        <Form.Item {...styleTabLayout} className="formItem" name="mobileBanner" label="بنر موبایل">
                            <div className="upload-description">
                                <div>اندازه مناسب : 100 × 600 </div>
                                <div>حجم مناسب : حداکثر 40KB</div>
                                <div>فقط عکس قابل قبول است</div>
                            </div>
                            <UploadRow
                                fileName={mobileBannerName}
                                onChange={(e) => handleChange(e, 'mobile')}
                                onDelete={() => { deleteBannerFiles(mobileBannerName, 'mobile'); setMobileBannerName(''); }}
                                helper="PNG/JPG • حداکثر 40KB"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider />
                <Form.Item {...styleTabLayout} className="formItem" name="footerLogo" label="لوگوی فوتر">
                    <div className="upload-description">
                        <div>حجم مناسب : حداکثر 20KB</div>
                        <div>فقط عکس قابل قبول است</div>
                    </div>
                    <UploadRow
                        fileName={footerLogoName}
                        onChange={(e) => handleChange(e, 'footerLogo')}
                        onDelete={() => deleteMainFiles('footerlogo', 'business-footerlogo')}
                        helper="PNG/JPG • حداکثر 20KB"
                    />
                </Form.Item>
            </div>
            <Modal
                open={isPreviewVisible}
                onCancel={() => setIsPreviewVisible(false)}
                footer={null}
                centered
                width={720}
                destroyOnClose
                // bodyStyle={{ textAlign: 'center' }}
            >
                {previewSrc && <Image src={previewSrc} alt="preview" style={{ maxHeight: '70vh', objectFit: 'contain' }} />}
            </Modal>
        </Form>
    )
}

export default BusinessUploads